<template>
    <div class="modal-chaoxian" v-if="isVisible">
        <div class="chaoxian-content">
            <div class="chaoxian-header">
                <h2 v-html="textcontent"></h2>
            </div>
            <div class="button-container">
                <button class="ok-button" @click="closeModal">
                    OK
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        textcontent: {
            type: String,
            default: "",
        },

    },
    components: {
    },
    data() {
        return {
            isVisible: false,
        };
    },
    methods: {
        openModal() {
            this.isVisible = true;
        },
        closeModal() {
            this.isVisible = false;
        },
    },
};
</script>

<style lang="less" scoped>
.modal-chaoxian {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(4px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;

    .chaoxian-content {
        background-color: #ffffff;
        border-radius: 16px;
        padding: 32px;
        width: 90%;
        max-width: 500px;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
    }

    .chaoxian-header {
        text-align: center;
        margin-bottom: 28px;

        h2 {
            color: #1a1a1a;
            font-size: 18px;
            line-height: 1.6;
            margin: 0;

            span {
                color: #ff4d4f;
                font-weight: 600;
            }
        }
    }

    .button-container {
        text-align: right;
    }

    .ok-button {
        background-color: #4a90e2;
        color: white;
        border: none;
        border-radius: 12px;
        padding: 12px 24px;
        font-size: 16px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.2s ease;
        box-shadow: 0 2px 8px rgba(74, 144, 226, 0.2);

        &:hover {
            background-color: #357abd;
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(74, 144, 226, 0.3);
        }
    }
}
</style>